import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Kit from './Kit';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

const Kits = () => {
  const [kits, setKits] = useState([]);
  const history = useHistory();

  const fetchKits = () => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/kits', { method: 'GET' })
      .then((res) => res.json())
      .then((data) => setKits(data));
  };

  const handleEvent = (kit, editMode) => {
    history.push({ pathname: '/kit/' + kit._id, kitid: kit._id, state: { kit, editMode } });
  };

  const createKit = () => {
    history.push({ pathname: '/kit/new', state: { createMode: true, kit: { no: '', description: '', Appareils: [] } } });
  };

  const deleteKit = (kit) => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/kits/' + kit._id, { method: 'DELETE' })
      .then(fetchKits);
  };

  useEffect(() => {
    fetchKits();
  }, []);

  return (
    <div>
      <h1>Kits</h1>
      <List component="nav" aria-label="secondary mailbox folders">
        {kits.map((kit) => (
          <ListItem button key={kit._id} onClick={() => handleEvent(kit, false)}>
            <ListItemText>#{kit.no} - {kit.description}<Kit _id={kit._id} /></ListItemText>
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="edit" onClick={() => handleEvent(kit, true)}><EditIcon /></IconButton>
              <IconButton edge="end" aria-label="delete" onClick={() => deleteKit(kit)}><DeleteIcon /></IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Button variant="contained" color="primary" onClick={createKit}>Ajouter</Button>
    </div>
  );
};

export default Kits;



// WEBPACK FOOTER //
// src/components/kits/Kits.js